"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = exports.ENotificationType = exports.EAuthProvider = void 0;
const Base_1 = require("./Base");
const Common_1 = require("./Common");
const index_1 = require("../index");
var EAuthProvider;
(function (EAuthProvider) {
    EAuthProvider["NONE"] = "";
    EAuthProvider["GOOGLE"] = "google.com";
    EAuthProvider["MICROSOFT"] = "microsoft";
    EAuthProvider["YAHOO"] = "yahoo";
})(EAuthProvider || (exports.EAuthProvider = EAuthProvider = {}));
var ENotificationType;
(function (ENotificationType) {
    ENotificationType["NONE"] = "";
    ENotificationType["EMAIL"] = "email";
})(ENotificationType || (exports.ENotificationType = ENotificationType = {}));
class User extends Base_1.Base {
    auth = EAuthProvider.NONE;
    contact_id = '';
    nick_name = '';
    first_name = '';
    last_name = '';
    email = '';
    phone = '';
    company = '';
    zip = '';
    photoURL = '';
    // signature?: string = '';
    metadata = {};
    location_id = ''; // deprecate?
    tax = null; // deprecate?
    optin = false;
    role = '';
    type = '';
    online = null;
    unread = {};
    claims = {};
    terms = []; // Store the TOS version and date accepted.
    notifications = ENotificationType.EMAIL;
    location = null;
    addresses = [];
    cards = [];
    devices = [];
    _roles = {};
    _root = false;
    _m = ['nick_name', 'name', 'first_name', 'last_name', 'email', 'phone', 'contact_id', 'photoURL'];
    set name(n) {
        if (n) {
            let name_parts = n.split(/ /);
            switch (name_parts.length) {
                case 1:
                    this.first_name = n;
                    break;
                case 2:
                    this.first_name = name_parts[0];
                    this.last_name = name_parts[1];
                    break;
                default:
                    this.first_name = name_parts[0];
                    name_parts.splice(0, 1);
                    this.last_name = name_parts.join(' ');
                    break;
            }
        }
    }
    get name() {
        let r = `${(this.first_name) ? this.first_name : ''}${(this.last_name) ? ' ' + this.last_name : ''}`;
        ['email', 'phone'].forEach(p => {
            if (!r) {
                r = this[p];
            }
        });
        return r;
    }
    constructor(data, olMap) {
        super('users', 25);
        (0, Common_1.setObjectProperties)(this, data, olMap, User);
        if (!(this.terms instanceof Array)) {
            this.terms = [];
        }
        if (this.metadata.terms && !this.terms?.includes(t => t.version === this.metadata.terms.version)) {
            this.terms.push(this.metadata.terms);
            delete this.metadata.terms;
        }
        // console.log('this.terms',this.terms);
    }
    toString() {
        return `User: ${this.name || this.email || (0, Common_1.prettifyPhone)(this.phone)}`;
    }
    getAddress(type) {
        let result = null;
        if (this.addresses && this.addresses.length) {
            this.addresses.forEach((addy) => {
                if (addy.type === type && (addy.default || (!result && addy.active))) {
                    result = addy;
                }
            });
        }
        return result;
    }
    toJSON() {
        this.active = this.active || false;
        this.location_id = this.location?.id || this.location_id;
        return super.toJSON();
    }
    toMiniJSON() {
        return {
            id: this.id,
            name: this.name || '',
            email: this.email || '',
            _type: this._type
        };
    }
}
exports.User = User;
index_1.olm.users = (ref, map) => {
    return new User(ref, map);
};
